import { createSelector, Selector } from '@ngrx/store';
import { selectShared } from './shared.selectors';
import { IdentifiedAssistEvent } from '../models';
import { Pack } from '@cue/data';

export const myEvents: Selector<any, Pack<IdentifiedAssistEvent[]>> = createSelector(
  selectShared,
  (state) => state.myEvents
);
